import React, { useState, useEffect } from "react";
import Navbar from "../../components/navbar/Navbar";
import "./Documentation.css";

/* ─── DATA ─────────────────────────────────────────────────────────── */
const GARAGE_AGREE_DATA = {
  villes: [
    { id: 1,  ville: "AGADIR",      region: "AGADIR" },
    { id: 2,  ville: "AIT MELLOUL", region: "AGADIR" },
    { id: 3,  ville: "KHOURIBGA",   region: "BENI MELLAL" },
    { id: 4,  ville: "CASABLANCA",  region: "CASABLANCA" },
    { id: 5,  ville: "MEDIOUNA",    region: "CASABLANCA" },
    { id: 6,  ville: "ERRACHIDIA",  region: "ERRACHIDIA" },
    { id: 7,  ville: "SAFI",        region: "ESSAOUIRA" },
    { id: 8,  ville: "FES",         region: "FES" },
    { id: 9,  ville: "KENITRA",     region: "KENITRA" },
    { id: 10, ville: "MARRAKECH",   region: "MARRAKECH" },
    { id: 11, ville: "AZROU",       region: "MEKNES" },
    { id: 12, ville: "MEKNES",      region: "MEKNES" },
    { id: 13, ville: "OUEZZANE",    region: "MEKNES" },
    { id: 14, ville: "DRIOUCH",     region: "NADOR" },
    { id: 15, ville: "NADOR",       region: "NADOR" },
    { id: 16, ville: "OUJDA",       region: "OUJDA" },
    { id: 17, ville: "RABAT",       region: "RABAT" },
    { id: 18, ville: "SALÉ",        region: "RABAT" },
    { id: 19, ville: "GUELMIM",     region: "SAHARA" },
    { id: 20, ville: "LAAYOUNE",    region: "SAHARA" },
    { id: 21, ville: "SETTAT",      region: "SETTAT" },
    { id: 22, ville: "TANGER",      region: "TANGER" },
    { id: 23, ville: "TETOUAN",     region: "TETOUAN" },
  ],
  generatedAt: "31 Mars 2026",
};

/* ─── SVG ICONS ─────────────────────────────────────────────────────── */
const IconHouse = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
    <polyline points="9 22 9 12 15 12 15 22"/>
  </svg>
);

const IconCompass = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"/>
    <polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76"/>
  </svg>
);

const IconSearch = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="11" cy="11" r="8"/>
    <line x1="21" y1="21" x2="16.65" y2="16.65"/>
    <line x1="11" y1="8" x2="11" y2="14"/>
    <line x1="8" y1="11" x2="14" y2="11"/>
  </svg>
);

const IconFile = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
    <polyline points="14 2 14 8 20 8"/>
    <line x1="16" y1="13" x2="8" y2="13"/>
    <line x1="16" y1="17" x2="8" y2="17"/>
    <polyline points="10 9 9 9 8 9"/>
  </svg>
);

const DOC_CARDS = [
  {
    id: "garage-agree",
    icon: <IconHouse />,
    title: "Garages Agréés",
    description: "Liste des villes disposant d'un Garage Agréé sur tout le territoire marocain.",
    active: true,
  },
  {
    id: "orientation",
    icon: <IconCompass />,
    title: "Orientation",
    description: "Règles d'orientation des dossiers selon les critères définis par la plateforme.",
    active: true,
  },
  {
    id: "etude-constats",
    icon: <IconFile />,
    title: "Etude Constats",
    description: "Méthodologie d'étude et d'analyse des constats d'accidents et de sinistres.",
    active: true,
  },
  {
    id: "etudes-expertise",
    icon: <IconSearch />,
    title: "Etudes Expertise",
    description: "Référentiel des études d'expertise véhicule et critères d'évaluation des dommages.",
    active: true,
  },
];

/* ─── DATA RÉSEAU ───────────────────────────────────────────────────── */
const RMA_SERVICE_DATA = [
  { id: 1, ville: "CASABLANCA", region: "CASABLANCA" },
  { id: 2, ville: "MARRAKECH",  region: "MARRAKECH" },
  { id: 3, ville: "RABAT",      region: "RABAT" },
  { id: 4, ville: "TANGER",     region: "TANGER" },
  { id: 5, ville: "SALE",       region: "RABAT" },
  { id: 6, ville: "TEMARA",     region: "RABAT" },
  { id: 7, ville: "TIT MELLIL", region: "CASABLANCA" },
  { id: 8, ville: "MEDIOUNA",   region: "CASABLANCA" },
  { id: 9, ville: "BOUSKOURA",  region: "CASABLANCA" },
  { id: 10, ville: "BOUKHALEF", region: "TANGER" },
];

// Extrait depuis regions_avec_vehicules.json — toutes les villes avec concessionnaire:true
const CONCESSIONNAIRE_DATA = [
  { id: 1,  ville: "AGADIR",        region: "AGADIR",       concessionnaires: { "Auto Nejma Agadir": ["MERCEDES","BYD"], "Sopriam Agadir": ["PEUGEOT","CITROËN","DS"], "Global Engines Agadir": ["HYUNDAI"], "AUTO HALL AGADIR": ["OPEL","FORD","DFSK","NISSAN","MITSUBISHI","FIAT","CHERY","JEEP","ALFA ROMEO"], "TOYOTA DU MAROC AGADIR": ["TOYOTA","LEXUS","DAIHATSU","SUBARU"], "Kia Motors Agadir": ["KIA"] } },
  { id: 2,  ville: "TIZNIT",        region: "AGADIR",       concessionnaires: { "AUTO HALL TIZNIT": ["OPEL","FORD","DFSK","NISSAN","MITSUBISHI","FIAT","CHERY","JEEP","ALFA ROMEO"] } },
  { id: 3,  ville: "BENI MELLAL",   region: "BENI MELLAL",  concessionnaires: { "AUTO HALL BENI MELLAL": ["OPEL","FORD","DFSK","NISSAN","MITSUBISHI","FIAT","CHERY","JEEP","ALFA ROMEO"] } },
  { id: 4,  ville: "KHOURIBGA",     region: "BENI MELLAL",  concessionnaires: { "AUTO HALL KHOURIBGA": ["OPEL","FORD","DFSK","NISSAN","MITSUBISHI","FIAT","CHERY","JEEP","ALFA ROMEO"] } },
  { id: 5,  ville: "CASABLANCA",    region: "CASABLANCA",   concessionnaires: { "SMEIA JAMA Auto": ["BMW","MINI","Jaguar","Land Rover","Mazda","XPeng"], "Auto Nejma Lissasfa": ["MERCEDES","BYD"], "SOPRIAM Sidi Maarouf": ["PEUGEOT","CITROËN","DS"], "AUTO HALL CASA": ["OPEL","FORD","DFSK","NISSAN","MITSUBISHI","FIAT","CHERY","JEEP","ALFA ROMEO"], "TOYOTA DU MAROC": ["TOYOTA","LEXUS","DAIHATSU","SUBARU"], "M-AUTOMOTIV": ["RENAULT","DACIA","ALPINE"], "Univers Motors Asie": ["HONDA"], "Global Engines Casablanca": ["HYUNDAI"], "Kia Motors Casablanca": ["HYUNDAI","KIA"], "Scandinavian Auto Casablanca": ["VOLVO"] } },
  { id: 6,  ville: "EL JADIDA",     region: "EL JADIDA",    concessionnaires: { "TOYOTA DU MAROC EL JADIDA": ["TOYOTA","LEXUS","DAIHATSU","SUBARU"], "SOPRIAM EL JADIDA": ["PEUGEOT","CITROËN","DS"], "Global Engines El Jadida": ["HYUNDAI"], "AUTO HALL JORF LASFAR": ["OPEL","FORD","DFSK","NISSAN","MITSUBISHI","FIAT","CHERY","JEEP","ALFA ROMEO"] } },
  { id: 7,  ville: "SAFI",          region: "ESSAOUIRA",    concessionnaires: { "AUTO HALL SAFI": ["OPEL","FORD","DFSK","NISSAN","MITSUBISHI","FIAT","CHERY","JEEP","ALFA ROMEO"] } },
  { id: 8,  ville: "FES",           region: "FES",          concessionnaires: { "SMEIA FES": ["BMW","MINI","Jaguar","Land Rover","Mazda","XPeng"], "Scandinavian Auto Fes": ["VOLVO"], "Global Engines Fes": ["HYUNDAI"], "AUTO HALL FES": ["OPEL","FORD","DFSK","NISSAN","MITSUBISHI","FIAT","CHERY","JEEP","ALFA ROMEO"], "SOPRIAM FES": ["PEUGEOT","CITROËN","DS"], "TOYOTA DU MAROC FES": ["TOYOTA","LEXUS","DAIHATSU","SUBARU"] } },
  { id: 9,  ville: "KENITRA",       region: "KENITRA",      concessionnaires: { "SOPRIAM KENITRA": ["PEUGEOT","CITROËN","DS"], "Auto Hall Kenitra": ["OPEL","FORD","DFSK","NISSAN","MITSUBISHI","FIAT","CHERY","JEEP","ALFA ROMEO"], "Globale Engines Kenitra": ["HYUNDAI"] } },
  { id: 10, ville: "MARRAKECH",     region: "MARRAKECH",    concessionnaires: { "SMEIA MARRAKECH": ["BMW","MINI","Jaguar","Land Rover","Mazda","XPeng"], "Scandinavian Auto Marrakech": ["VOLVO"], "AUTO HALL MARRAKECH": ["OPEL","FORD","DFSK","NISSAN","MITSUBISHI","FIAT","CHERY","JEEP","ALFA ROMEO"], "SOPRIAM MARRAKECH": ["PEUGEOT","CITROËN","DS"], "TOYOTA DU MAROC MARRAKECH": ["TOYOTA","LEXUS","DAIHATSU","SUBARU"], "Global Engines Marrakech": ["HYUNDAI"], "Kia Motors Marrakech": ["KIA"], "Auto Nejma Marrakech": ["MERCEDES","BYD"] } },
  { id: 11, ville: "MEKNES",        region: "MEKNES",       concessionnaires: { "AUTO HALL MEKNES": ["OPEL","FORD","DFSK","NISSAN","MITSUBISHI","FIAT","CHERY","JEEP","ALFA ROMEO"], "SOPRIAM MEKNES": ["PEUGEOT","CITROËN","DS"], "Dounia Auto": ["AUDI","DACIA","FIAT","FORD","HYUNDAI","JEEP","KIA","MERCEDES","PEUGEOT","RENAULT","TOYOTA","VOLKSWAGEN"] } },
  { id: 12, ville: "NADOR",         region: "NADOR",        concessionnaires: { "AUTO HALL NADOR": ["OPEL","FORD","DFSK","NISSAN","MITSUBISHI","FIAT","CHERY","JEEP","ALFA ROMEO"], "NADIN AUTOMOTIVE": ["AUDI","DACIA","FORD","MERCEDES","PEUGEOT","RENAULT"] } },
  { id: 13, ville: "OUJDA",         region: "OUJDA",        concessionnaires: { "SMEIA OUJDA": ["BMW","MINI","Jaguar","Land Rover","Mazda","XPeng"], "SOPRIAM OUJDA": ["PEUGEOT","CITROËN","DS"], "Global Engines Oujda": ["HYUNDAI"], "AUTO HALL OUJDA": ["OPEL","FORD","DFSK","NISSAN","MITSUBISHI","FIAT","CHERY","JEEP","ALFA ROMEO"], "Auto Nejma Oujda": ["MERCEDES","BYD"] } },
  { id: 14, ville: "RABAT",         region: "RABAT",        concessionnaires: { "SMEIA RYAD AUTO RABAT": ["BMW","MINI","Jaguar","Land Rover","Mazda","XPeng"], "Scandinavian Auto Rabat": ["VOLVO"], "SOPRIAM RABAT": ["PEUGEOT","CITROËN","DS"], "AUTO HALL RABAT": ["OPEL","FORD","DFSK","NISSAN","MITSUBISHI","FIAT","CHERY","JEEP","ALFA ROMEO"], "TOYOTA DU MAROC RABAT": ["TOYOTA","LEXUS","DAIHATSU","SUBARU"], "Kia Motors Rabat": ["KIA"], "Global Engines Rabat": ["HYUNDAI"], "Auto Nejma Rabat": ["MERCEDES","BYD"] } },
  { id: 15, ville: "SALE",          region: "RABAT",        concessionnaires: { "SGA Sopriam Salé": ["PEUGEOT","CITROËN","DS"], "AUTO HALL SALE": ["OPEL","FORD","DFSK","NISSAN","MITSUBISHI","FIAT","CHERY","JEEP","ALFA ROMEO"] } },
  { id: 16, ville: "TEMARA",        region: "RABAT",        concessionnaires: { "M-Automotiv Temara": ["RENAULT","DACIA","ALPINE"] } },
  { id: 17, ville: "SETTAT",        region: "SETTAT",       concessionnaires: { "AUTO HALL Settat": ["OPEL","FORD","DFSK","NISSAN","MITSUBISHI","FIAT","CHERY","JEEP","ALFA ROMEO"] } },
  { id: 18, ville: "TANGER",        region: "TANGER",       concessionnaires: { "SMEIA TANGER": ["BMW","MINI","Jaguar","Land Rover","Mazda","XPeng"], "Scandinavian Auto Tanger": ["VOLVO"], "SOPRIAM TANGER": ["PEUGEOT","CITROËN","DS"], "Global Engines Tanger": ["HYUNDAI"], "AUTO HALL TANGER": ["OPEL","FORD","DFSK","NISSAN","MITSUBISHI","FIAT","CHERY","JEEP","ALFA ROMEO"], "STE BOUGHAZ AUTO": ["DACIA","RENAULT"], "TOYOTA DU MAROC TANGER": ["TOYOTA","LEXUS","DAIHATSU","SUBARU"], "Kia Motors Tanger": ["KIA"], "Auto Nejma Tanger": ["MERCEDES","BYD"] } },
  { id: 19, ville: "TETOUAN",       region: "TETOUAN",      concessionnaires: { "SOPRIAM TETOUAN": ["PEUGEOT","CITROËN","DS"], "AUTO HALL TETOUAN": ["OPEL","FORD","DFSK","NISSAN","MITSUBISHI","FIAT","CHERY","JEEP","ALFA ROMEO"] } },
  { id: 20, ville: "MOHAMMEDIA",    region: "MOHAMMEDIA",   concessionnaires: { "SMVN": ["NISSAN"], "SOPRIAM ZENATA": ["PEUGEOT","CITROËN","DS"], "Scandinavian Auto Casablanca": ["VOLVO"], "Top Auto": ["DACIA","LAND ROVER","RENAULT","VOLKSWAGEN"] } },
  { id: 21, ville: "BERRECHID",     region: "BERRECHID",    concessionnaires: { "M-AUTOMOTIV Lissasfa": ["RENAULT","DACIA","ALPINE"], "Univers Auto": ["DACIA","RENAULT"] } },
  { id: 22, ville: "LARACHE",       region: "LARACHE",      concessionnaires: { "Samadi Auto": ["DACIA","RENAULT"] } },
  { id: 23, ville: "FKIH BEN SALEH",region: "BENI MELLAL",  concessionnaires: { "HBID AUTO": [] } },
];

const RESEAU_TABS = [
  { id: "ga",              label: "Garages Agréés",   icon: "🏢", color: "#3b82f6" },
  { id: "rma",             label: "RMA Service",       icon: "🔴", color: "#dc2626" },
  { id: "concessionnaire", label: "Concessionnaire",   icon: "🏪", color: "#059669" },
];

const ALL_VILLES = Array.from(new Set([
  ...RMA_SERVICE_DATA.map((v) => v.ville),
  ...GARAGE_AGREE_DATA.villes.map((v) => v.ville),
  ...CONCESSIONNAIRE_DATA.map((v) => v.ville),
])).sort();

const ALL_MARQUES = Array.from(new Set(
  CONCESSIONNAIRE_DATA.flatMap((v) => Object.values(v.concessionnaires).flat())
)).sort();

// Vérifie la disponibilité RMA Service / Garage Agréé / Concessionnaire pour une ville donnée
function checkVilleServices(villeUpper, marque) {
  const rmaDispo = RMA_SERVICE_DATA.some((v) => v.ville.toUpperCase() === villeUpper);
  const ga = GARAGE_AGREE_DATA.villes.some((v) => v.ville.toUpperCase() === villeUpper);
  const concessVille = CONCESSIONNAIRE_DATA.find((v) => v.ville.toUpperCase() === villeUpper);

  let concessionnaire = false;
  if (concessVille) {
    if (!marque) {
      concessionnaire = true;
    } else {
      const marqueUpper = marque.trim().toUpperCase();
      concessionnaire = Object.values(concessVille.concessionnaires).some((list) =>
        list.some((m) => m.toUpperCase() === marqueUpper)
      );
    }
  }

  return { rmaDispo, ga, concessionnaire, villeTrouvee: rmaDispo || ga || !!concessVille };
}

// Reproduit fidèlement calculer_orientation() de Backend/services/OrientationService.py
function simulateOrientation({ prixTotal, dmcAnnees, rc, compagnieAdverse, ville, marque }) {
  const adverseEstRma = (compagnieAdverse || "").trim().toUpperCase() === "RMA";
  const villeUpper = ville ? ville.trim().toUpperCase() : "";
  const dmcVide = dmcAnnees === null || dmcAnnees === undefined || dmcAnnees === "";

  const services = villeUpper
    ? checkVilleServices(villeUpper, marque)
    : { rmaDispo: false, ga: false, concessionnaire: false, villeTrouvee: false };

  let { rmaDispo, ga, concessionnaire, villeTrouvee } = services;

  const dmc = dmcVide ? 3 : Number(dmcAnnees);
  if (dmc > 25) rmaDispo = false;
  if (dmc > 5) concessionnaire = false;

  const steps = [];
  let orientation = null;
  let ruleHit = null;

  const r1cond = prixTotal >= 20000 && rc === 0 && !adverseEstRma;
  steps.push({
    priority: 1,
    title: "Prix ≥ 20 000 DH · RC = 0 · Adverse ≠ RMA",
    applies: r1cond,
    detail: `Prix ${prixTotal >= 20000 ? "≥" : "<"} 20 000 (${prixTotal} DH) · RC ${rc === 0 ? "=" : "≠"} 0 (${rc}) · Adverse ${adverseEstRma ? "= RMA" : "≠ RMA"}`,
  });
  if (!orientation && r1cond) {
    ruleHit = 1;
    orientation = concessionnaire ? "CONCESSIONNAIRE" : rmaDispo ? "RMA SERVICE" : ga ? "GA" : "PN";
  }

  const r2cond = dmc < 2;
  steps.push({
    priority: 2,
    title: "DMC < 2 ans",
    applies: r2cond,
    detail: `DMC = ${dmc} an(s)${dmcVide ? " (valeur par défaut, non renseignée)" : ""}`,
  });
  if (!orientation && r2cond) {
    ruleHit = 2;
    orientation = rmaDispo ? "RMA SERVICE" : concessionnaire ? "CONCESSIONNAIRE" : ga ? "GA" : "PN";
  }

  const r3cond = prixTotal < 5000;
  steps.push({
    priority: 3,
    title: "Prix < 5 000 DH",
    applies: r3cond,
    detail: `Prix = ${prixTotal} DH → EAD (quel que soit le remplacement de pièces)`,
  });
  if (!orientation && r3cond) {
    ruleHit = 3;
    orientation = "EAD";
  }

  const r4cond = prixTotal >= 5000;
  steps.push({
    priority: 4,
    title: "Prix ≥ 5 000 DH (cas générique)",
    applies: r4cond,
    detail: `Prix = ${prixTotal} DH`,
  });
  if (!orientation && r4cond) {
    ruleHit = 4;
    orientation = rmaDispo ? "RMA SERVICE" : ga ? "GA" : "EAD";
  }

  if (!orientation) {
    ruleHit = "fallback";
    orientation = rmaDispo ? "RMA SERVICE" : ga ? "GA" : "PN";
  }

  return {
    orientation,
    ruleHit,
    steps,
    services: { rmaDispo, ga, concessionnaire },
    dmc,
    dmcVide,
    villeTrouvee,
  };
}

const ORIENTATION_RULES = [
  {
    priority: 1,
    label: "Priorité 1",
    title: "Prix ≥ 20 000 DH · RC = 0 · Adverse ≠ RMA",
    color: "#dc2626",
    conditions: [
      "Prix total ≥ 20 000 DH",
      "RC = 0 (responsabilité nulle)",
      "Compagnie adverse ≠ RMA",
    ],
    results: [
      { orientation: "CONCESSIONNAIRE", condition: "Si concessionnaire disponible" },
      { orientation: "RMA SERVICE",     condition: "Sinon, si RMA Service disponible" },
      { orientation: "GA",              condition: "Sinon, si Garage Agréé disponible" },
      { orientation: "PN",              condition: "Sinon" },
    ],
    example: {
      params: { prixTotal: 25000, dmcAnnees: 3, rc: 0, compagnieAdverse: "AXA", ville: "CASABLANCA", marque: "MARQUE_INCONNUE" },
      text: (r) => `Casablanca · 25 000 DH · RC 0 · adverse AXA · marque non représentée → concessionnaire indisponible, RMA Service ${r.services.rmaDispo ? "disponible" : "indisponible"} → `,
    },
  },
  {
    priority: 2,
    label: "Priorité 2",
    title: "DMC < 2 ans",
    color: "#d97706",
    conditions: [
      "Date de mise en circulation < 2 ans",
      "DMC null → traité comme > 2 ans",
    ],
    results: [
      { orientation: "RMA SERVICE",     condition: "Si RMA Service disponible (DMC ≤ 25 ans)" },
      { orientation: "CONCESSIONNAIRE", condition: "Sinon, si concessionnaire disponible (DMC ≤ 5 ans)" },
      { orientation: "GA",              condition: "Sinon, si Garage Agréé disponible" },
      { orientation: "PN",              condition: "Sinon" },
    ],
    example: {
      params: { prixTotal: 15000, dmcAnnees: 1, rc: 1, compagnieAdverse: "AXA", ville: "CASABLANCA" },
      text: (r) => `Casablanca · 15 000 DH · DMC 1 an (< 2 ans, priorité sur le prix) → RMA Service ${r.services.rmaDispo ? "disponible" : "indisponible"} → `,
    },
  },
  {
    priority: 3,
    label: "Priorité 3",
    title: "Prix < 5 000 DH",
    color: "#0d9488",
    conditions: [
      "Prix total < 5 000 DH",
    ],
    results: [
      { orientation: "EAD", condition: "Toujours — quel que soit le remplacement de pièces" },
    ],
    example: {
      params: { prixTotal: 3000, dmcAnnees: 3, rc: 0, compagnieAdverse: "AXA", ville: "CASABLANCA" },
      text: () => `Casablanca · 3 000 DH (avec ou sans remplacement de pièces) → `,
    },
  },
  {
    priority: 4,
    label: "Priorité 4",
    title: "Prix ≥ 5 000 DH (cas générique)",
    color: "#3b82f6",
    conditions: [
      "Prix total ≥ 5 000 DH",
      "Aucune règle précédente ne s'applique",
    ],
    results: [
      { orientation: "RMA SERVICE", condition: "Si RMA Service disponible" },
      { orientation: "GA",          condition: "Sinon, si Garage Agréé disponible" },
      { orientation: "EAD",         condition: "Sinon" },
    ],
    example: {
      params: { prixTotal: 5500, dmcAnnees: 3, rc: 50, compagnieAdverse: "RMA", ville: "CASABLANCA" },
      text: (r) => `Casablanca · 5 500 DH · adverse RMA · RC 50 → règles 1-3 ne s'appliquent pas → RMA Service ${r.services.rmaDispo ? "disponible" : "indisponible"} → `,
    },
  },
];

const ORIENTATION_CONSTRAINTS = [
  { icon: "🚗", text: "DMC > 25 ans → RMA SERVICE indisponible" },
  { icon: "🔧", text: "DMC > 5 ans → CONCESSIONNAIRE indisponible" },
  { icon: "📍", text: "Si ville absente → fallback sur la région" },
  { icon: "⚠️", text: "Si ville et région absentes → RMA=❌ · Concess=❌ · GA=❌" },
];

const ORIENTATION_LEGEND = [
  { code: "RMA SERVICE",     desc: "Réparation dans un atelier RMA agréé" },
  { code: "CONCESSIONNAIRE", desc: "Réparation chez le concessionnaire de la marque" },
  { code: "GA",              desc: "Garage Agréé local" },
  { code: "EAD",             desc: "Expertise à distance" },
  { code: "PN",              desc: "Prise en charge normale (hors réseau agréé)" },
];


const ORIENTATION_BADGE_COLORS = {
  "RMA SERVICE":     "#dc2626",
  "CONCESSIONNAIRE": "#059669",
  "GA":              "#3b82f6",
  "EAD":             "#0d9488",
  "PN":              "#6c757d",
};

/* ─── DATA ETUDE CONSTATS ───────────────────────────────────────────── */
const WORKFLOW_STEPS = [
  {
    step: 1,
    color: "#3b82f6",
    icon: "👤",
    title: "Vérifier les informations personnelles & véhicule",
    items: [
      "Nom, prénom et coordonnées de l'assuré",
      "Immatriculation, marque, modèle et année du véhicule",
      "Numéro de police et compagnie d'assurance",
      "Cohérence entre les données affichées et le dossier physique",
    ],
  },
  {
    step: 2,
    color: "#d97706",
    icon: "📋",
    title: "Vérifier l'étude du constat",
    items: [
      "Niveau de responsabilité (RC) bien déterminé",
      "Circonstances de l'accident claires et cohérentes",
      "Rubrique constat correctement renseignée ou lien du constat bien figé",
      "Compagnie adverse identifiée si sinistre tiers",
    ],
  },
  {
    step: 3,
    color: "#dc2626",
    icon: "🚗",
    title: "Vérifier les côtés endommagés",
    items: [
      "Images affichées correspondent aux dommages déclarés",
      "Côtés endommagés cohérents avec les circonstances du constat",
      "Liste des pièces détectées par l'IA est complète et plausible",
      "Chiffres (montants, quantités) sont cohérents avec les dégâts visibles",
    ],
  },
  {
    step: 4,
    color: "#7c3aed",
    icon: "🧭",
    title: "Décider la bonne orientation",
    items: [
      "Appliquer les règles d'orientation selon prix, DMC, RC et ville",
      "Vérifier la disponibilité RMA Service / Concessionnaire / GA",
      "Sélectionner l'orientation appropriée dans le dossier",
      "Consulter la rubrique Orientation pour les règles détaillées",
    ],
  },
  {
    step: 5,
    color: "#059669",
    icon: "💾",
    title: "Sauvegarder le dossier",
    items: [
      "S'assurer que tous les champs obligatoires sont renseignés",
      "Valider les modifications apportées aux dommages",
      "Confirmer l'orientation choisie avant la sauvegarde",
      "Sauvegarder le dossier pour finaliser le traitement",
    ],
  },
];

/* ─── DATA ETUDE CONSTATS ───────────────────────────────────────────── */
const CONSTAT_SECTIONS = [
  {
    id: "infos-generales",
    icon: "📅",
    color: "#3b82f6",
    title: "Informations générales",
    fields: [
      { label: "Date & heure", desc: "Date et heure exacte de l'accident — ex : 2026-04-18 à 21:00" },
      { label: "Lieu précis", desc: "Adresse exacte où s'est produit l'accident — ex : DAR BOUAZZA" },
      { label: "Dégâts matériels tiers", desc: "OUI/NON — présence de dégâts sur d'autres biens que les véhicules A et B" },
      { label: "Témoins", desc: "Nom, adresse et téléphone des témoins éventuels" },
    ],
  },
  {
    id: "vehicule-a",
    icon: "🚗",
    color: "#2563eb",
    title: "Véhicule A (assuré déclarant)",
    fields: [
      { label: "Marque / Type", desc: "Marque et modèle du véhicule — ex : Renault Express" },
      { label: "Immatriculation", desc: "Numéro de plaque ou numéro moteur" },
      { label: "Compagnie d'assurance", desc: "Nom de la compagnie — ex : RMA ASSURANCE" },
      { label: "N° police / attestation", desc: "Références du contrat d'assurance et validité" },
      { label: "Conducteur", desc: "Nom, prénom, adresse, numéro et catégorie du permis de conduire" },
      { label: "Point de choc", desc: "Flèche indiquant la zone de premier impact sur le schéma du véhicule" },
      { label: "Dégâts apparents", desc: "Description textuelle des dommages visibles — ex : FACE ARRIÈRE GAUCHE" },
    ],
  },
  {
    id: "vehicule-b",
    icon: "🚙",
    color: "#7c3aed",
    title: "Véhicule B (adverse)",
    fields: [
      { label: "Marque / Type", desc: "Marque et modèle du véhicule adverse — ex : C50 DOCKER" },
      { label: "Immatriculation", desc: "Numéro de plaque du véhicule adverse" },
      { label: "Compagnie d'assurance", desc: "Compagnie adverse — ex : AXA ASSURANCE MAROC" },
      { label: "N° police / attestation", desc: "Références du contrat et période de validité" },
      { label: "Conducteur", desc: "Identité du conducteur adverse (peut différer du propriétaire)" },
      { label: "Point de choc", desc: "Zone d'impact adverse — ex : FACE AVANT" },
    ],
  },
  {
    id: "circonstances",
    icon: "📋",
    color: "#d97706",
    title: "Cases circonstances (1 à 23)",
    fields: [
      { label: "Case 1",  desc: "Heurtait à l'arrière dans le même sens et sur une même file" },
      { label: "Case 2",  desc: "Roulait dans le même sens sur une file différente" },
      { label: "Case 3",  desc: "Roulait en sens inverse" },
      { label: "Case 4",  desc: "Provenait d'une chaussée différente" },
      { label: "Case 5",  desc: "Venait de droite dans un carrefour" },
      { label: "Case 6",  desc: "S'engageait sur une place à sens giratoire" },
      { label: "Case 7",  desc: "Roulait sur une place à sens giratoire" },
      { label: "Case 8",  desc: "En stationnement" },
      { label: "Case 9",  desc: "Quittait un stationnement" },
      { label: "Case 10", desc: "Prenait un stationnement" },
      { label: "Case 11", desc: "Reculait" },
      { label: "Case 12", desc: "Doublait (dépassait)" },
      { label: "Case 13", desc: "Dépassement irrégulier" },
      { label: "Case 14", desc: "Changeait de file" },
      { label: "Case 15", desc: "Virait à droite" },
      { label: "Case 16", desc: "Virait à gauche" },
      { label: "Case 17", desc: "S'engageait dans un parking, un lieu privé ou un chemin de terre" },
      { label: "Case 18", desc: "Sortait d'un parking, d'un lieu privé ou d'un chemin de terre" },
      { label: "Case 19", desc: "Empiétait sur la voie réservée au sens inverse" },
      { label: "Case 20", desc: "Roulait en sens interdit" },
      { label: "Case 21", desc: "N'a pas respecté un signal de priorité" },
      { label: "Case 22", desc: "Faisait un demi-tour" },
      { label: "Case 23", desc: "Ouvrait une portière" }
    ],
    note: "Chaque conducteur coche les cases qui décrivent son comportement au moment de l'accident. Plus une case est cochée par un seul conducteur, plus elle indique sa responsabilité.",
  },
  {
    id: "responsabilite",
    icon: "⚖️",
    color: "#dc2626",
    title: "Analyser la responsabilité (RC)",
    fields: [
      { label: "Conducteur A coche 0 cases", desc: "→ Pas de responsabilité déclarée côté A" },
      { label: "Conducteur B coche 1 case", desc: "→ Responsabilité probable côté B (ex : case 1 = heurtait à l'arrière)" },
      { label: "Cases cochées des deux côtés", desc: "→ Responsabilité partagée à analyser selon les cases cochées" },
      { label: "Case 1 cochée par B", desc: "→ B venait de derrière dans le même sens → responsabilité B probable" },
      { label: "Case 21 cochée", desc: "→ Non-respect de priorité → responsabilité directe" },
    ],
    note: "Le constat ne constitue pas une reconnaissance de responsabilité — c'est un relevé des faits. La responsabilité est déterminée par l'expert selon les cases cochées, les dégâts et le croquis.",
  },
  {
    id: "croquis",
    icon: "🗺️",
    color: "#059669",
    title: "Croquis & observations",
    fields: [
      { label: "Croquis de l'accident", desc: "Schéma dessiné par les conducteurs montrant la position des véhicules au moment du choc" },
      { label: "Observations A", desc: "Commentaire libre du conducteur A sur les circonstances — ex : 'FACE ARRIÈRE GAUCHE S R E'" },
      { label: "Observations B", desc: "Commentaire libre du conducteur B" },
      { label: "Circonstance commentaire libre", desc: "Zone de texte libre pour décrire les circonstances en détail" },
    ],
  },
];

const CONSTAT_TIPS = [
  { icon: "✅", text: "Vérifier que les deux conducteurs ont bien signé le constat" },
  { icon: "✅", text: "S'assurer que les attestations d'assurance sont en cours de validité" },
  { icon: "✅", text: "Comparer les cases cochées avec les dégâts décrits — cohérence obligatoire" },
  { icon: "✅", text: "Le nombre de cases cochées par chaque conducteur est clé pour évaluer le RC" },
  { icon: "⚠️", text: "Un constat incomplet ou non signé peut invalider la déclaration de sinistre" },
  { icon: "⚠️", text: "Les dégâts sur d'autres biens (case Dégâts tiers = OUI) nécessitent une procédure complémentaire" },
];

/* ─── COMPOSANTS PARTAGÉS DES FENÊTRES ──────────────────────────────── */
const Svg = ({ size = 18, children }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    {children}
  </svg>
);
const IcSearch  = (p) => <Svg {...p}><circle cx="11" cy="11" r="7" /><line x1="21" y1="21" x2="16.65" y2="16.65" /></Svg>;
const IcX       = (p) => <Svg {...p}><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></Svg>;
const IcChevron = (p) => <Svg {...p}><polyline points="6 9 12 15 18 9" /></Svg>;
const IcCheck   = (p) => <Svg {...p}><polyline points="20 6 9 17 4 12" /></Svg>;
const IcReset   = (p) => <Svg {...p}><polyline points="1 4 1 10 7 10" /><path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10" /></Svg>;
const IcExternal = (p) => <Svg {...p}><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" /><polyline points="15 3 21 3 21 9" /><line x1="10" y1="14" x2="21" y2="3" /></Svg>;
const IcArrow   = (p) => <Svg {...p}><line x1="5" y1="12" x2="19" y2="12" /><polyline points="12 5 19 12 12 19" /></Svg>;
const IcInfo    = (p) => <Svg {...p}><circle cx="12" cy="12" r="10" /><line x1="12" y1="16" x2="12" y2="12" /><line x1="12" y1="8" x2="12.01" y2="8" /></Svg>;
const IcWarn    = (p) => <Svg {...p}><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" /><line x1="12" y1="9" x2="12" y2="13" /><line x1="12" y1="17" x2="12.01" y2="17" /></Svg>;
const IcPlay    = (p) => <Svg {...p}><polygon points="5 3 19 12 5 21 5 3" /></Svg>;

const norm = (s) => String(s ?? "").toLowerCase();

// Surligne la première occurrence de la recherche dans un texte
const Highlight = ({ text, query }) => {
  const t = String(text ?? "");
  const q = (query || "").trim();
  if (!q) return t;
  const i = t.toLowerCase().indexOf(q.toLowerCase());
  if (i < 0) return t;
  return (
    <>
      {t.slice(0, i)}
      <mark className="dx-mark">{t.slice(i, i + q.length)}</mark>
      {t.slice(i + q.length)}
    </>
  );
};

// Fenêtre : fond, en-tête, onglets, corps défilant, pied. Échap est géré par la page.
const PopupShell = ({ icon, title, subtitle, onClose, footer, tabs, activeTab, onTabChange, tabsLabel, wide, children }) => {
  const boxRef = React.useRef(null);

  useEffect(() => {
    boxRef.current?.focus();
  }, []);

  // Garde le focus clavier dans la fenêtre
  const onKeyDown = (e) => {
    if (e.key !== "Tab" || !boxRef.current) return;
    const items = boxRef.current.querySelectorAll(
      'button:not([disabled]), input:not([disabled]), select:not([disabled]), a[href], iframe, [tabindex="0"]'
    );
    if (!items.length) return;
    const first = items[0];
    const last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  };

  const onTabKey = (e, i) => {
    if (!["ArrowRight", "ArrowLeft", "Home", "End"].includes(e.key)) return;
    e.preventDefault();
    let n = i;
    if (e.key === "ArrowRight") n = (i + 1) % tabs.length;
    if (e.key === "ArrowLeft") n = (i - 1 + tabs.length) % tabs.length;
    if (e.key === "Home") n = 0;
    if (e.key === "End") n = tabs.length - 1;
    onTabChange(tabs[n].id);
    e.currentTarget.parentElement.children[n]?.focus();
  };

  return (
    <div className="dx-overlay" onMouseDown={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div
        ref={boxRef}
        className={`dx-box${wide ? " dx-box--wide" : ""}`}
        role="dialog"
        aria-modal="true"
        aria-label={title}
        tabIndex={-1}
        onKeyDown={onKeyDown}
      >
        <header className="dx-header">
          <span className="dx-header-icon">{icon}</span>
          <div className="dx-header-text">
            <h2 className="dx-title">{title}</h2>
            {subtitle && <p className="dx-subtitle">{subtitle}</p>}
          </div>
          <button type="button" className="dx-close" onClick={onClose} aria-label="Fermer"><IcX /></button>
        </header>

        {tabs && (
          <div className="dx-tabs" role="tablist" aria-label={tabsLabel}>
            {tabs.map((t, i) => (
              <button
                key={t.id}
                type="button"
                role="tab"
                id={`dx-tab-${t.id}`}
                aria-selected={activeTab === t.id}
                aria-controls="dx-panel"
                tabIndex={activeTab === t.id ? 0 : -1}
                className={`dx-tab${activeTab === t.id ? " is-active" : ""}`}
                onClick={() => onTabChange(t.id)}
                onKeyDown={(e) => onTabKey(e, i)}
              >
                {t.dot && <span className="dx-tab-dot" style={{ background: t.dot }} />}
                <span>{t.label}</span>
                {t.count !== undefined && <span className="dx-tab-count">{t.count}</span>}
              </button>
            ))}
          </div>
        )}

        <div className="dx-body" id="dx-panel" role={tabs ? "tabpanel" : undefined} aria-labelledby={tabs ? `dx-tab-${activeTab}` : undefined}>
          {children}
        </div>

        <footer className="dx-footer">
          <span className="dx-footer-text">{footer}</span>
          <button type="button" className="dx-btn dx-btn--primary" onClick={onClose}>Fermer</button>
        </footer>
      </div>
    </div>
  );
};

const SearchField = ({ value, onChange, placeholder, label }) => (
  <div className="dx-search">
    <IcSearch size={16} />
    <input
      type="text"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      aria-label={label || placeholder}
    />
    {value && (
      <button type="button" className="dx-search-clear" onClick={() => onChange("")} aria-label="Effacer la recherche">
        <IcX size={14} />
      </button>
    )}
  </div>
);

const EmptyBlock = ({ title, hint, onReset }) => (
  <div className="dx-empty">
    <IcSearch size={32} />
    <p className="dx-empty-title">{title}</p>
    {hint && <p className="dx-empty-hint">{hint}</p>}
    {onReset && <button type="button" className="dx-btn" onClick={onReset}>Réinitialiser les filtres</button>}
  </div>
);

/* ─── POPUP RÉSEAU AGRÉÉ ────────────────────────────────────────────── */
const RESEAU_ACCENTS = { ga: "#3b82f6", rma: "#dc2626", concessionnaire: "#059669" };

const villeCoverage = (villeUpper) => ({
  rma: RMA_SERVICE_DATA.some((v) => v.ville.toUpperCase() === villeUpper),
  ga: GARAGE_AGREE_DATA.villes.some((v) => v.ville.toUpperCase() === villeUpper),
  concessionnaire: CONCESSIONNAIRE_DATA.some((v) => v.ville.toUpperCase() === villeUpper),
});

const GarageAgreePopup = ({ onClose }) => {
  const [activeTab, setActiveTab] = useState("ga");
  const [search, setSearch] = useState("");
  const [filterRegion, setFilterRegion] = useState("Toutes");
  const [filterMarque, setFilterMarque] = useState("Toutes");
  const [sort, setSort] = useState({ key: "id", dir: "asc" });

  const resetFilters = () => { setSearch(""); setFilterRegion("Toutes"); setFilterMarque("Toutes"); };
  const handleTabChange = (tab) => { setActiveTab(tab); resetFilters(); setSort({ key: "id", dir: "asc" }); };
  const toggleSort = (key) =>
    setSort((s) => (s.key === key ? { key, dir: s.dir === "asc" ? "desc" : "asc" } : { key, dir: "asc" }));

  const allMarques = React.useMemo(() => {
    const marques = new Set();
    CONCESSIONNAIRE_DATA.forEach((v) => Object.values(v.concessionnaires).forEach((l) => l.forEach((m) => marques.add(m))));
    return Array.from(marques).sort((a, b) => a.localeCompare(b, "fr"));
  }, []);

  const currentData =
    activeTab === "ga" ? GARAGE_AGREE_DATA.villes :
    activeTab === "rma" ? RMA_SERVICE_DATA :
    CONCESSIONNAIRE_DATA;

  const regions = React.useMemo(
    () => Array.from(new Set(currentData.map((v) => v.region))).sort((a, b) => a.localeCompare(b, "fr")),
    [currentData]
  );

  const q = norm(search).trim();

  // GA / RMA : lignes ville ; Concessionnaire : villes avec leurs concessionnaires filtrés
  const rows = React.useMemo(() => {
    const regionOk = (v) => filterRegion === "Toutes" || v.region === filterRegion;
    const factor = sort.dir === "asc" ? 1 : -1;
    const cmp = (a, b) =>
      (sort.key === "id" ? a.id - b.id : String(a[sort.key]).localeCompare(String(b[sort.key]), "fr")) * factor;

    if (activeTab !== "concessionnaire") {
      return currentData
        .filter((v) => regionOk(v) && (!q || norm(v.ville).includes(q) || norm(v.region).includes(q)))
        .sort(cmp);
    }
    return CONCESSIONNAIRE_DATA
      .filter(regionOk)
      .map((v) => {
        const villeMatch = !q || norm(v.ville).includes(q) || norm(v.region).includes(q);
        const entries = Object.entries(v.concessionnaires).filter(([name, marques]) => {
          const marqueOk = filterMarque === "Toutes" || marques.includes(filterMarque);
          const textOk = villeMatch || norm(name).includes(q) || marques.some((m) => norm(m).includes(q));
          return marqueOk && textOk;
        });
        return { ...v, entries };
      })
      .filter((v) => v.entries.length > 0)
      .sort(cmp);
  }, [activeTab, currentData, q, filterRegion, filterMarque, sort]);

  const filtersActive = Boolean(q) || filterRegion !== "Toutes" || (activeTab === "concessionnaire" && filterMarque !== "Toutes");
  const accent = RESEAU_ACCENTS[activeTab];
  const totalLabel =
    activeTab === "ga" ? `${GARAGE_AGREE_DATA.villes.length} villes agréées` :
    activeTab === "rma" ? `${RMA_SERVICE_DATA.length} villes RMA` :
    `${CONCESSIONNAIRE_DATA.length} villes avec concessionnaire`;

  const tabs = RESEAU_TABS.map((t) => ({
    id: t.id,
    label: t.label,
    dot: RESEAU_ACCENTS[t.id],
    count: t.id === "ga" ? GARAGE_AGREE_DATA.villes.length : t.id === "rma" ? RMA_SERVICE_DATA.length : CONCESSIONNAIRE_DATA.length,
  }));

  const sortTh = (k, children) => (
    <th aria-sort={sort.key === k ? (sort.dir === "asc" ? "ascending" : "descending") : "none"}>
      <button type="button" className={`dx-th-sort${sort.key === k ? " is-sorted" : ""}`} onClick={() => toggleSort(k)}>
        {children}
        <span className="dx-th-icon" style={sort.key === k && sort.dir === "desc" ? { transform: "rotate(180deg)" } : undefined}>
          <IcChevron size={14} />
        </span>
      </button>
    </th>
  );

  const Cov = ({ ok, current }) => (
    <span className={`dx-cov${ok ? " is-ok" : ""}${current ? " is-current" : ""}`} title={ok ? "Disponible" : "Non disponible"}>
      {ok ? <IcCheck size={14} /> : "—"}
    </span>
  );

  return (
    <PopupShell
      icon={<IconHouse />}
      title="Réseau Agréé — Maroc"
      subtitle={`Garages Agréés · RMA Service · Concessionnaires · Mis à jour le ${GARAGE_AGREE_DATA.generatedAt}`}
      onClose={onClose}
      footer={`Document officiel CheckAI · ${totalLabel}`}
      tabs={tabs}
      activeTab={activeTab}
      onTabChange={handleTabChange}
      tabsLabel="Type de réseau"
      wide
    >
      <div className="dx-toolbar">
        <SearchField
          value={search}
          onChange={setSearch}
          placeholder={activeTab === "concessionnaire" ? "Rechercher une ville, un concessionnaire ou une marque…" : "Rechercher une ville ou une région…"}
        />
        <select className="dx-select" value={filterRegion} onChange={(e) => setFilterRegion(e.target.value)} aria-label="Filtrer par région">
          <option value="Toutes">Toutes les régions</option>
          {regions.map((r) => <option key={r} value={r}>{r}</option>)}
        </select>
        {activeTab === "concessionnaire" && (
          <select className="dx-select" value={filterMarque} onChange={(e) => setFilterMarque(e.target.value)} aria-label="Filtrer par marque">
            <option value="Toutes">Toutes les marques</option>
            {allMarques.map((m) => <option key={m} value={m}>{m}</option>)}
          </select>
        )}
      </div>

      <div className="dx-resultbar">
        <span className="dx-result-count">
          <span className="dx-dot" style={{ background: accent }} />
          <strong>{rows.length}</strong> ville{rows.length > 1 ? "s" : ""}
          {filtersActive && <> sur {currentData.length}</>}
        </span>
        {filtersActive && (
          <button type="button" className="dx-link" onClick={resetFilters}><IcReset size={13} /> Réinitialiser</button>
        )}
      </div>

      {rows.length === 0 ? (
        <EmptyBlock title="Aucun résultat" hint="Essayez un autre terme ou retirez un filtre." onReset={filtersActive ? resetFilters : null} />
      ) : activeTab === "concessionnaire" ? (
        <div className="dx-ville-list">
          {rows.map((v) => (
            <section key={v.id} className="dx-ville-card">
              <header className="dx-ville-head">
                <h3 className="dx-ville-name"><Highlight text={v.ville} query={q} /></h3>
                <span className="dx-pill">{v.region}</span>
                <span className="dx-ville-count">{v.entries.length} concessionnaire{v.entries.length > 1 ? "s" : ""}</span>
              </header>
              <ul className="dx-conc-list">
                {v.entries.map(([name, marques]) => (
                  <li key={name} className="dx-conc-row">
                    <span className="dx-conc-name"><Highlight text={name} query={q} /></span>
                    <span className="dx-brands">
                      {marques.length ? marques.map((m) => (
                        <span key={m} className={`dx-brand${filterMarque === m || (q && norm(m).includes(q)) ? " is-match" : ""}`}>{m}</span>
                      )) : <span className="dx-brand dx-brand--empty">Non spécifié</span>}
                    </span>
                  </li>
                ))}
              </ul>
            </section>
          ))}
        </div>
      ) : (
        <div className="dx-table-wrap">
          <table className="dx-table">
            <thead>
              <tr>
                {sortTh("id", "#")}
                {sortTh("ville", "Ville")}
                {sortTh("region", "Région")}
                <th className="dx-center">RMA</th>
                <th className="dx-center">Garage</th>
                <th className="dx-center">Concess.</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((v) => {
                const cov = villeCoverage(v.ville.toUpperCase());
                return (
                  <tr key={v.id}>
                    <td className="dx-td-num">{v.id}</td>
                    <td className="dx-td-strong"><Highlight text={v.ville} query={q} /></td>
                    <td className="dx-td-muted"><Highlight text={v.region} query={q} /></td>
                    <td className="dx-center"><Cov ok={cov.rma} current={activeTab === "rma"} /></td>
                    <td className="dx-center"><Cov ok={cov.ga} current={activeTab === "ga"} /></td>
                    <td className="dx-center"><Cov ok={cov.concessionnaire} /></td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </PopupShell>
  );
};

/* ─── POPUP ORIENTATION ─────────────────────────────────────────────── */
const ORIENTATION_TABS = [
  { id: "regles", label: "Règles" },
  { id: "simulateur", label: "Simulateur" },
];

const DEFAULT_SIM_FORM = {
  prixTotal: 15000,
  dmcConnue: true,
  dmcAnnees: 3,
  rc: 0,
  compagnieAdverse: "",
  ville: "CASABLANCA",
  marque: "",
};

const formFromExample = (p) => ({
  prixTotal: p.prixTotal,
  dmcConnue: true,
  dmcAnnees: p.dmcAnnees ?? 3,
  rc: p.rc === 0 ? 0 : 1,
  compagnieAdverse: p.compagnieAdverse || "",
  ville: p.ville || "",
  marque: p.marque || "",
});

const OrientBadge = ({ code, small }) => (
  <span className={`dx-obadge${small ? " dx-obadge--sm" : ""}`} style={{ "--oc": ORIENTATION_BADGE_COLORS[code] || "#6b7280" }}>
    {code}
  </span>
);

const OrientationSimulateur = ({ form, setForm }) => {
  const update = (field, value) => setForm((f) => ({ ...f, [field]: value }));

  // Résultat recalculé à chaque modification : pas de bouton à presser
  const result = React.useMemo(
    () =>
      simulateOrientation({
        prixTotal: Number(form.prixTotal) || 0,
        dmcAnnees: form.dmcConnue ? Number(form.dmcAnnees) : null,
        rc: Number(form.rc),
        compagnieAdverse: form.compagnieAdverse,
        ville: form.ville,
        marque: form.marque,
      }),
    [form]
  );

  const hitRule = typeof result.ruleHit === "number" ? ORIENTATION_RULES.find((r) => r.priority === result.ruleHit) : null;
  const color = ORIENTATION_BADGE_COLORS[result.orientation] || "#6b7280";
  const legend = ORIENTATION_LEGEND.find((l) => l.code === result.orientation);
  const villeSaisie = form.ville.trim() !== "";

  return (
    <div className="dx-sim">
      <section className="dx-sim-form" aria-label="Paramètres du dossier">
        <div className="dx-presets">
          <span className="dx-presets-label">Charger un exemple</span>
          {ORIENTATION_RULES.map((r) => (
            <button key={r.priority} type="button" className="dx-preset" style={{ "--c": r.color }} onClick={() => setForm(formFromExample(r.example.params))}>
              P{r.priority}
            </button>
          ))}
          <button type="button" className="dx-link" onClick={() => setForm(DEFAULT_SIM_FORM)}><IcReset size={13} /> Réinitialiser</button>
        </div>

        <div className="dx-fields">
          <div className="dx-field">
            <label htmlFor="sim-prix">Prix total (DH)</label>
            <input id="sim-prix" type="number" inputMode="numeric" min={0} value={form.prixTotal} onChange={(e) => update("prixTotal", e.target.value)} />
          </div>

          <div className="dx-field">
            <span className="dx-field-label" id="sim-rc-label">Responsabilité (RC)</span>
            <div className="dx-seg" role="group" aria-labelledby="sim-rc-label">
              <button type="button" className={Number(form.rc) === 0 ? "is-active" : ""} aria-pressed={Number(form.rc) === 0} onClick={() => update("rc", 0)}>RC = 0</button>
              <button type="button" className={Number(form.rc) !== 0 ? "is-active" : ""} aria-pressed={Number(form.rc) !== 0} onClick={() => update("rc", 1)}>Engagée</button>
            </div>
          </div>

          <div className="dx-field">
            <label htmlFor="sim-adverse">Compagnie adverse</label>
            <input id="sim-adverse" type="text" placeholder="RMA, AXA, …" value={form.compagnieAdverse} onChange={(e) => update("compagnieAdverse", e.target.value)} />
          </div>

          <div className="dx-field">
            <label htmlFor="sim-dmc">Ancienneté du véhicule (DMC)</label>
            <input id="sim-dmc" type="number" inputMode="numeric" min={0} value={form.dmcAnnees} disabled={!form.dmcConnue} onChange={(e) => update("dmcAnnees", e.target.value)} />
            <label className="dx-check">
              <input type="checkbox" checked={!form.dmcConnue} onChange={(e) => update("dmcConnue", !e.target.checked)} />
              DMC inconnue (traitée comme 3 ans)
            </label>
          </div>

          <div className="dx-field">
            <label htmlFor="sim-ville">Ville</label>
            <input id="sim-ville" type="text" list="doc-sim-villes" placeholder="Ex : CASABLANCA" value={form.ville} onChange={(e) => update("ville", e.target.value)} />
            <datalist id="doc-sim-villes">{ALL_VILLES.map((v) => <option key={v} value={v} />)}</datalist>
          </div>

          <div className="dx-field">
            <label htmlFor="sim-marque">Marque <span className="dx-optional">(optionnel)</span></label>
            <input id="sim-marque" type="text" list="doc-sim-marques" placeholder="Ex : RENAULT" value={form.marque} onChange={(e) => update("marque", e.target.value)} />
            <datalist id="doc-sim-marques">{ALL_MARQUES.map((m) => <option key={m} value={m} />)}</datalist>
          </div>
        </div>
      </section>

      <section className="dx-sim-result" aria-live="polite" aria-label="Résultat">
        <div className="dx-result-hero" style={{ "--oc": color }}>
          <span className="dx-result-kicker">Orientation</span>
          <span className="dx-result-code">{result.orientation}</span>
          {legend && <span className="dx-result-desc">{legend.desc}</span>}
          <span className="dx-result-rule">
            {result.ruleHit === "fallback"
              ? "Règle de secours"
              : <>Déclenchée par la <strong>Priorité {result.ruleHit}</strong>{hitRule ? ` · ${hitRule.title}` : ""}</>}
          </span>
        </div>

        <div className="dx-avail" aria-label="Disponibilité dans la ville">
          {[
            ["RMA Service", result.services.rmaDispo],
            ["Concessionnaire", result.services.concessionnaire],
            ["Garage Agréé", result.services.ga],
          ].map(([label, ok]) => (
            <span key={label} className={`dx-avail-chip${ok ? " is-ok" : ""}`}>
              {ok ? <IcCheck size={13} /> : <IcX size={13} />} {label}
            </span>
          ))}
        </div>
        {villeSaisie && !result.villeTrouvee && (
          <p className="dx-note dx-note--warn"><IcWarn size={16} /> Ville non reconnue dans le réseau : aucune disponibilité.</p>
        )}

        <h3 className="dx-subhead">Cheminement des règles</h3>
        <ol className="dx-steps">
          {result.steps.map((s) => {
            const isHit = result.ruleHit === s.priority;
            const skipped = typeof result.ruleHit === "number" && result.ruleHit < s.priority;
            const state = isHit ? "hit" : skipped ? "skipped" : s.applies ? "ok" : "fail";
            return (
              <li key={s.priority} className={`dx-step dx-step--${state}`}>
                <span className="dx-step-mark">{skipped ? "—" : s.applies ? <IcCheck size={13} /> : <IcX size={13} />}</span>
                <div>
                  <div className="dx-step-title">Priorité {s.priority} · {s.title}</div>
                  <div className="dx-step-detail">{skipped ? "Non évaluée : une règle précédente a déjà décidé." : s.detail}</div>
                </div>
              </li>
            );
          })}
        </ol>
      </section>
    </div>
  );
};

const OrientationPopup = ({ onClose }) => {
  const [activeTab, setActiveTab] = useState("regles");
  const [form, setForm] = useState(DEFAULT_SIM_FORM);

  const tryRule = (rule) => {
    setForm(formFromExample(rule.example.params));
    setActiveTab("simulateur");
  };

  return (
    <PopupShell
      icon={<IconCompass />}
      title="Règles d'Orientation des Dossiers"
      subtitle="4 règles par ordre de priorité · Plateforme CheckAI"
      onClose={onClose}
      footer="Document officiel CheckAI · OrientationService"
      tabs={ORIENTATION_TABS}
      activeTab={activeTab}
      onTabChange={setActiveTab}
      tabsLabel="Sections d'orientation"
      wide
    >
      {activeTab === "simulateur" ? (
        <OrientationSimulateur form={form} setForm={setForm} />
      ) : (
        <>
          <div className="dx-callout">
            <IcInfo size={18} />
            <p>Les règles sont évaluées <strong>dans l'ordre</strong> : dès qu'une règle s'applique, elle fixe l'orientation et les suivantes sont ignorées.</p>
          </div>

          <h3 className="dx-section-title">Parcours de décision</h3>
          <ol className="dx-flow">
            {ORIENTATION_RULES.map((r, i) => (
              <li key={r.priority} className="dx-flow-node" style={{ "--c": r.color }}>
                <span className="dx-flow-num">{r.priority}</span>
                <span className="dx-flow-text">{r.title}</span>
                {i < ORIENTATION_RULES.length - 1 && <span className="dx-flow-arrow" aria-hidden="true"><IcArrow size={14} /></span>}
              </li>
            ))}
          </ol>

          <h3 className="dx-section-title">Règles de décision</h3>
          <div className="dx-rules">
            {ORIENTATION_RULES.map((rule) => {
              const ex = simulateOrientation(rule.example.params);
              return (
                <article key={rule.priority} className="dx-rule" style={{ "--c": rule.color }}>
                  <header className="dx-rule-head">
                    <span className="dx-rule-badge">{rule.label}</span>
                    <h4 className="dx-rule-title">{rule.title}</h4>
                    <button type="button" className="dx-btn dx-btn--sm" onClick={() => tryRule(rule)}>
                      <IcPlay size={12} /> Tester
                    </button>
                  </header>
                  <div className="dx-rule-body">
                    <div>
                      <p className="dx-mini-label">Conditions</p>
                      <ul className="dx-cond-list">
                        {rule.conditions.map((c, i) => <li key={i}>{c}</li>)}
                      </ul>
                    </div>
                    <div>
                      <p className="dx-mini-label">Résultats (dans l'ordre)</p>
                      <ol className="dx-res-list">
                        {rule.results.map((r, i) => (
                          <li key={i}>
                            <OrientBadge code={r.orientation} small />
                            <span>{r.condition}</span>
                          </li>
                        ))}
                      </ol>
                    </div>
                  </div>
                  <p className="dx-rule-example">
                    <span className="dx-tag">Exemple</span>
                    {rule.example.text(ex)}
                    <OrientBadge code={ex.orientation} small />
                  </p>
                </article>
              );
            })}
          </div>

          <h3 className="dx-section-title">Contraintes automatiques</h3>
          <ul className="dx-constraints">
            {ORIENTATION_CONSTRAINTS.map((c, i) => (
              <li key={i}><span aria-hidden="true">{c.icon}</span><span>{c.text}</span></li>
            ))}
          </ul>

          <h3 className="dx-section-title">Légende des orientations</h3>
          <ul className="dx-legend">
            {ORIENTATION_LEGEND.map((l) => (
              <li key={l.code}>
                <OrientBadge code={l.code} />
                <span>{l.desc}</span>
              </li>
            ))}
          </ul>
        </>
      )}
    </PopupShell>
  );
};

/* ─── POPUP ETUDE CONSTATS ──────────────────────────────────────────── */
const CONSTAT_TABS = [
  { id: "guide", label: "Guide de lecture" },
  { id: "exemple", label: "Exemple de constat" },
];
const CONSTAT_PDF = "/Econstat-758028%20(1).pdf";

const EtudeConstatsPopup = ({ onClose }) => {
  const [tab, setTab] = useState("guide");
  const [open, setOpen] = useState(() => new Set());
  const [query, setQuery] = useState("");
  const q = norm(query).trim();

  const toggle = (id) =>
    setOpen((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id); else next.add(id);
      return next;
    });

  // Avec une recherche : seules les sections concernées restent, champs filtrés, tout est déplié
  const sections = React.useMemo(() => {
    if (!q) return CONSTAT_SECTIONS.map((s) => ({ ...s, shown: s.fields }));
    return CONSTAT_SECTIONS
      .map((s) => {
        const titleMatch = norm(s.title).includes(q);
        const shown = titleMatch ? s.fields : s.fields.filter((f) => norm(f.label).includes(q) || norm(f.desc).includes(q));
        return { ...s, shown };
      })
      .filter((s) => s.shown.length > 0);
  }, [q]);

  const isOpen = (id) => (q ? true : open.has(id));
  const allOpen = !q && open.size === CONSTAT_SECTIONS.length;
  const matchCount = sections.reduce((n, s) => n + s.shown.length, 0);

  const oks = CONSTAT_TIPS.filter((t) => t.icon !== "⚠️");
  const warns = CONSTAT_TIPS.filter((t) => t.icon === "⚠️");

  return (
    <PopupShell
      icon={<IconFile />}
      title="Comment lire un Constat Amiable"
      subtitle="Guide de lecture · Constat automobile Maroc · CheckAI"
      onClose={onClose}
      footer="Document officiel CheckAI · Constat amiable Maroc"
      tabs={CONSTAT_TABS}
      activeTab={tab}
      onTabChange={setTab}
      tabsLabel="Sections du guide"
      wide
    >
      {tab === "exemple" ? (
        <div className="dx-example">
          <div className="dx-callout">
            <IcInfo size={18} />
            <p>Constat réel anonymisé — Accident du 18/04/2026 · DAR BOUAZZA · Véhicule A : Renault Express (RMA) · Véhicule B : C50 Docker (AXA)</p>
          </div>

          <div className="dx-pdf">
            <div className="dx-pdf-bar">
              <span>Constat amiable (PDF)</span>
              <a className="dx-btn dx-btn--sm" href={CONSTAT_PDF} target="_blank" rel="noopener noreferrer">
                <IcExternal size={13} /> Ouvrir dans un onglet
              </a>
            </div>
            <iframe src={CONSTAT_PDF} className="dx-pdf-frame" title="Exemple de constat amiable" />
          </div>

          <h3 className="dx-section-title">Lecture de l'exemple</h3>
          <div className="dx-read-grid">
            <div className="dx-read" style={{ "--c": "#2563eb" }}>
              <span className="dx-read-label">Véhicule A</span>
              <p>Renault Express · RMA ASSURANCE · DIAJ Ahmed · Fkih Ben Saleh</p>
              <strong>0 case cochée</strong>
            </div>
            <div className="dx-read" style={{ "--c": "#7c3aed" }}>
              <span className="dx-read-label">Véhicule B</span>
              <p>C50 Docker · AXA ASSURANCE · DRIDBA Marouane · Casablanca</p>
              <strong>1 case cochée (Case 1 : heurtait à l'arrière)</strong>
            </div>
            <div className="dx-read" style={{ "--c": "#dc2626" }}>
              <span className="dx-read-label">Conclusion RC</span>
              <p>B coche la case 1</p>
              <strong>Responsabilité probable du conducteur B</strong>
            </div>
          </div>
        </div>
      ) : (
        <>
          <div className="dx-callout">
            <IcInfo size={18} />
            <p>Le constat amiable est composé de <strong>2 côtés</strong> (Véhicule A et B), de <strong>23 cases de circonstances</strong> et d'un <strong>croquis</strong>. Chaque section a un rôle précis dans la détermination de la responsabilité.</p>
          </div>

          <h3 className="dx-section-title">Sections du constat</h3>
          <div className="dx-toolbar dx-toolbar--tight">
            <SearchField value={query} onChange={setQuery} placeholder="Rechercher un champ, une case…" />
            {!q && (
              <button
                type="button"
                className="dx-btn"
                onClick={() => setOpen(allOpen ? new Set() : new Set(CONSTAT_SECTIONS.map((s) => s.id)))}
              >
                {allOpen ? "Tout replier" : "Tout déplier"}
              </button>
            )}
          </div>
          {q && (
            <div className="dx-resultbar">
              <span className="dx-result-count"><strong>{matchCount}</strong> champ{matchCount > 1 ? "s" : ""} trouvé{matchCount > 1 ? "s" : ""}</span>
              <button type="button" className="dx-link" onClick={() => setQuery("")}><IcReset size={13} /> Effacer</button>
            </div>
          )}

          {sections.length === 0 ? (
            <EmptyBlock title="Aucun champ trouvé" hint="Essayez « case 1 », « permis », « assurance »…" onReset={() => setQuery("")} />
          ) : (
            <div className="dx-accordion">
              {sections.map((s) => {
                const expanded = isOpen(s.id);
                return (
                  <section key={s.id} className={`dx-acc${expanded ? " is-open" : ""}`} style={{ "--c": s.color }}>
                    <h4 className="dx-acc-h">
                      <button type="button" className="dx-acc-btn" aria-expanded={expanded} aria-controls={`acc-${s.id}`} onClick={() => !q && toggle(s.id)}>
                        <span className="dx-acc-icon" aria-hidden="true">{s.icon}</span>
                        <span className="dx-acc-title"><Highlight text={s.title} query={q} /></span>
                        <span className="dx-acc-meta">{s.fields.length} champs</span>
                        <span className="dx-acc-chev"><IcChevron size={18} /></span>
                      </button>
                    </h4>
                    {expanded && (
                      <div className="dx-acc-body" id={`acc-${s.id}`}>
                        <dl className="dx-defs">
                          {s.shown.map((f, i) => (
                            <div key={i} className="dx-def">
                              <dt><Highlight text={f.label} query={q} /></dt>
                              <dd><Highlight text={f.desc} query={q} /></dd>
                            </div>
                          ))}
                        </dl>
                        {s.note && !q && <p className="dx-note">{s.note}</p>}
                      </div>
                    )}
                  </section>
                );
              })}
            </div>
          )}

          <h3 className="dx-section-title">Points de vigilance</h3>
          <div className="dx-tips">
            <div className="dx-tip-col dx-tip-col--ok">
              <h4><IcCheck size={15} /> À vérifier</h4>
              <ul>{oks.map((t, i) => <li key={i}>{t.text}</li>)}</ul>
            </div>
            <div className="dx-tip-col dx-tip-col--warn">
              <h4><IcWarn size={15} /> Alertes</h4>
              <ul>{warns.map((t, i) => <li key={i}>{t.text}</li>)}</ul>
            </div>
          </div>
        </>
      )}
    </PopupShell>
  );
};

/* ─── POPUP ETUDES EXPERTISE ────────────────────────────────────────── */
const EtudesExpertisePopup = ({ onClose }) => {
  const [done, setDone] = useState(() => new Set());
  const total = WORKFLOW_STEPS.reduce((n, s) => n + s.items.length, 0);
  const key = (step, i) => `${step}-${i}`;

  const toggleItem = (k) =>
    setDone((prev) => {
      const next = new Set(prev);
      if (next.has(k)) next.delete(k); else next.add(k);
      return next;
    });

  const toggleStep = (s) => {
    const keys = s.items.map((_, i) => key(s.step, i));
    const all = keys.every((k) => done.has(k));
    setDone((prev) => {
      const next = new Set(prev);
      keys.forEach((k) => (all ? next.delete(k) : next.add(k)));
      return next;
    });
  };

  const pct = total ? Math.round((done.size / total) * 100) : 0;
  const complete = done.size === total;

  return (
    <PopupShell
      icon={<IconSearch />}
      title="Workflow de Traitement d'un Dossier"
      subtitle={`${WORKFLOW_STEPS.length} étapes après affichage du résultat IA · Plateforme CheckAI`}
      onClose={onClose}
      footer="Document officiel CheckAI · Procédure post-IA"
      wide
    >
      <div className={`dx-progress${complete ? " is-complete" : ""}`}>
        <div className="dx-progress-top">
          <span className="dx-progress-label">
            {complete ? "Toutes les vérifications sont faites" : "Votre progression"}
          </span>
          <span className="dx-progress-value">{done.size} / {total}</span>
          {done.size > 0 && (
            <button type="button" className="dx-link" onClick={() => setDone(new Set())}><IcReset size={13} /> Réinitialiser</button>
          )}
        </div>
        <div className="dx-bar" role="progressbar" aria-valuemin={0} aria-valuemax={100} aria-valuenow={pct} aria-label="Progression des vérifications">
          <span style={{ width: `${pct}%` }} />
        </div>
        <p className="dx-progress-hint">
          {complete ? "Le dossier est prêt pour la validation finale." : "Cochez chaque point au fur et à mesure : cette liste n'est pas enregistrée."}
        </p>
      </div>

      <h3 className="dx-section-title">Étapes à suivre</h3>
      <ol className="dx-wf">
        {WORKFLOW_STEPS.map((s) => {
          const count = s.items.filter((_, i) => done.has(key(s.step, i))).length;
          const stepDone = count === s.items.length;
          return (
            <li key={s.step} className={`dx-wf-step${stepDone ? " is-done" : ""}`} style={{ "--c": s.color }}>
              <div className="dx-wf-head">
                <span className="dx-wf-num">{stepDone ? <IcCheck size={16} /> : s.step}</span>
                <span className="dx-wf-icon" aria-hidden="true">{s.icon}</span>
                <h4 className="dx-wf-title">{s.title}</h4>
                <button type="button" className="dx-link dx-wf-all" onClick={() => toggleStep(s)}>
                  {stepDone ? "Décocher" : "Tout cocher"}
                </button>
                <span className="dx-wf-count">{count}/{s.items.length}</span>
              </div>
              <ul className="dx-wf-items">
                {s.items.map((item, i) => {
                  const k = key(s.step, i);
                  return (
                    <li key={k}>
                      <label className={`dx-tick${done.has(k) ? " is-checked" : ""}`}>
                        <input type="checkbox" checked={done.has(k)} onChange={() => toggleItem(k)} />
                        <span className="dx-tick-box" aria-hidden="true"><IcCheck size={12} /></span>
                        <span className="dx-tick-text">{item}</span>
                      </label>
                    </li>
                  );
                })}
              </ul>
            </li>
          );
        })}
      </ol>

      <p className="dx-callout dx-callout--note">
        <span aria-hidden="true">💡</span>
        Ces étapes doivent être suivies dans l'ordre pour garantir la qualité et la cohérence du dossier avant validation finale.
      </p>
    </PopupShell>
  );
};

/* ─── MAIN PAGE ─────────────────────────────────────────────────────── */
const Documentation = () => {
  const [activePopup, setActivePopup] = useState(null);

  const handleCardClick = (card) => {
    if (!card.active) return;
    setActivePopup(card.id);
  };

  // Fenêtre ouverte : Échap la ferme et la page derrière ne défile plus.
  useEffect(() => {
    if (!activePopup) return undefined;
    const onKey = (e) => { if (e.key === "Escape") setActivePopup(null); };
    const prevOverflow = document.body.style.overflow;
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = prevOverflow;
    };
  }, [activePopup]);

  const cardMeta = {
    "garage-agree": `${GARAGE_AGREE_DATA.villes.length} villes`,
    orientation: `${ORIENTATION_RULES.length} règles`,
  };

  return (
    <div className="doc-page">
      <Navbar username={localStorage.getItem("username") || "Guest"} />

      <div className="doc-container">

        <div className="doc-page-header">
          <p className="doc-page-eyebrow">Centre de documentation</p>
          <h1 className="doc-page-title">Guides & Références</h1>
          <p className="doc-page-desc">
            Retrouvez toutes les informations de référence nécessaires à l'utilisation de la plateforme CheckAI.
          </p>
        </div>

        <div className="doc-cards-grid">
          {DOC_CARDS.map((card) => (
            <button
              type="button"
              key={card.id}
              className={`doc-card ${card.active ? "doc-card--active" : "doc-card--disabled"}`}
              onClick={() => handleCardClick(card)}
              disabled={!card.active}
            >
              {!card.active && <div className="doc-card-soon-badge">Bientôt</div>}
              <div className="doc-card-top">
                <div className="doc-card-icon" aria-hidden="true">{card.icon}</div>
                {cardMeta[card.id] && <span className="doc-card-meta">{cardMeta[card.id]}</span>}
              </div>
              <h3 className="doc-card-title">{card.title}</h3>
              <p className="doc-card-desc">{card.description}</p>
              {card.active && (
                <span className="doc-card-cta">
                  Consulter
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                    <line x1="5" y1="12" x2="19" y2="12" /><polyline points="12 5 19 12 12 19" />
                  </svg>
                </span>
              )}
            </button>
          ))}
        </div>

      </div>

      {activePopup === "garage-agree"    && <GarageAgreePopup    onClose={() => setActivePopup(null)} />}
      {activePopup === "orientation"     && <OrientationPopup    onClose={() => setActivePopup(null)} />}
      {activePopup === "etude-constats"  && <EtudeConstatsPopup  onClose={() => setActivePopup(null)} />}
      {activePopup === "etudes-expertise"&& <EtudesExpertisePopup onClose={() => setActivePopup(null)} />}
    </div>
  );
};

export default Documentation;